import { useAuth0 } from "@auth0/auth0-react"
import React, { useMemo } from "react"
import BifrostTab from "../../../../../Components/BifrostElementComponent/BifrostTab/BifrostTab"
import UserDetailsSegment from "../../../../../Components/BifrostPageComponent/UserComponents/UserDetailsComponent/UserDetailSegment"
import { DeleteUserModal } from "../UserModal/DeleteUserModal/DeleteUserModal"
import { ResetMfaModal } from "../UserModal/ResetMfaModal/ResetMfaModal"
import "./UserDetails.scss"

const UserDetails = ({ data, setData, refresh }) => {
	const { user } = useAuth0()
	const detailData = useMemo(() => {
		return [
			{
				tabName: "Details",
				feature: true,
				featureName: null,
				featureIcon: "sliders",
				renderCondition: false,
				disabled: false,
				tabContent: <UserDetailsSegment data={data} setData={setData} />
			}
		]
	}, [data])

	const settings = useMemo(() => {
		return {
			refreshs: [
				{
					tab: "Details",
					refresh: () => refresh()
				}
			],
			options: [
				<DeleteUserModal key={"deleteUserModal"} disabled={data.email === user.email} id={data.id} navPath={"/users"} name={data.email} />,
				<ResetMfaModal key={"resetMFAModal"} id={data.id} name={data.email} />
			]
		}
	})

	const style = useMemo(() => {
		return {
			tabular: false,
			tabStyle: { marginBottom: "0px" },
			contentStyle: { padding: "0px" }
		}
	}, [])

	return (
		<div className={"user-detail-segment"}>
			<BifrostTab detailData={detailData} settings={settings} style={style} />
		</div>
	)
}

export default UserDetails
